import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class SvgWifiIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        level: PropTypes.number
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e',
        level: 100
    };

    render() {
        const { color, size, level } = this.props;
        return (
            <svg height={(size / 1.25).toString()} width={(size / 1.25).toString()} viewBox="0 0 300 280">
                <g fill={color}>
                    <path
                        d="M145.43,249.85A19,19,0,0,0,133,260.51c-1.57,3.44-1.85,4.93-1.85,9.18s.28,5.76,1.9,9.25a20.92,20.92,0,0,0,6.8,8,18.3,18.3,0,0,0,20.3,0,20.84,20.84,0,0,0,6.78-8c1.66-3.62,1.95-5,1.95-9.25s-.3-5.81-1.88-9.18a18.26,18.26,0,0,0-8.44-9A18.61,18.61,0,0,0,145.43,249.85Z"
                        transform="translate(0 -10)"
                        opacity={level >= 20 ? '1' : '0.3'}
                    />
                    <path
                        d="M144.26,170.66a73.86,73.86,0,0,0-22.74,5.76,80.66,80.66,0,0,0-17.82,11.21c-6.52,5.61-9.4,9.18-10.9,13.6a23.54,23.54,0,0,0-.59,12.27,22.38,22.38,0,0,0,6.49,10.68,23.06,23.06,0,0,0,7.22,3.95,24.25,24.25,0,0,0,9.61,0c3.63-1.13,5.74-2.51,9.38-6.06a36.61,36.61,0,0,1,17.91-10c2-.48,3.09-.55,7.17-.55s5.18.08,7.17.55a36.43,36.43,0,0,1,17.89,10c3.73,3.64,6.1,5.15,9.73,6.16a20,20,0,0,0,9,0,20.5,20.5,0,0,0,10.41-7.09,26.14,26.14,0,0,0,3.63-7.62,23.54,23.54,0,0,0-.59-12.27c-1.2-3.49-2.79-5.86-6.49-9.53a72.86,72.86,0,0,0-34.06-19.26A71,71,0,0,0,144.26,170.66Z"
                        transform="translate(0 -10)"
                        opacity={level >= 40 ? '1' : '0.3'}
                    />
                    <path
                        d="M142.74,88.84c-4.13.28-8.21.68-10.78,1-29.47,3.85-56.73,16.87-79.47,37.91-4,3.75-8.86,8.95-10,10.73a22.38,22.38,0,0,0-1.76,19.28c3.8,9.88,14.25,14.93,23.72,11.49,3.19-1.16,4.83-2.36,8.65-6.28a111.06,111.06,0,0,1,39.46-26.37,104.22,104.22,0,0,1,74.88,0c14.86,5.78,27.48,14.23,39.62,26.55,3.21,3.27,4.78,4.47,7.34,5.66a16.66,16.66,0,0,0,8.18,1.51,15.36,15.36,0,0,0,7-1.81,20.12,20.12,0,0,0,8.49-8.09,22.65,22.65,0,0,0,1.2-18.43c-1.1-2.87-2.56-4.93-6-8.55a146.83,146.83,0,0,0-54.74-36.07,140.09,140.09,0,0,0-35.24-8.07C160,88.94,145.64,88.64,142.74,88.84Z"
                        transform="translate(0 -10)"
                        opacity={level >= 60 ? '1' : '0.3'}
                    />
                    <path
                        d="M139.46,10.28C98.62,12.52,59.68,27.65,27.16,53.9,17,62.07,4.84,74,2.8,77.68A22.6,22.6,0,0,0,0,87.43c-.56,9.65,5.32,18.35,14.14,20.89a21.38,21.38,0,0,0,9.35.13,22.34,22.34,0,0,0,7.08-3.72c.68-.6,2.93-2.82,5-5C61.55,73.48,93.86,57,128.91,52.26a162.42,162.42,0,0,1,42.2,0,157.91,157.91,0,0,1,70.66,28.2,165.94,165.94,0,0,1,23.58,20.26c3.92,4,5.18,5.08,7.43,6.28a15.38,15.38,0,0,0,8.28,1.91,14.26,14.26,0,0,0,8.11-1.91c10.22-5.18,13.9-18.6,8-29.34-.91-1.66-6.52-7.77-11.11-12.14a200.63,200.63,0,0,0-71.15-44.27A193.61,193.61,0,0,0,139.46,10.28Z"
                        transform="translate(0 -10)"
                        opacity={level >= 80 ? '1' : '0.3'}
                    />
                </g>
            </svg>
        );
    }
}

export default withTheme(SvgWifiIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/SvgWifiIcon.js